import React, { Component }      from 'react';
import {connect}                 from 'react-redux';
import { Modal}           from 'react-bootstrap';
import {SetLikePostUser,
        GetTipoMidiaPost,
        GetQtdCommentPost,
        GetRemoverPostEquipe}    from '../../../actions/grupoAction';
        
import FlashRetornoNulo          from '../../../container/FlashRetornoNulo';
import EquipeAlunoComentarioPost from './equipe_aluno_comentario_post';
import BtAcaoComentario          from '../../../container/btAcaoRemoverItem';
import BtLikeEquipe              from '../../../container/bt_like_timeline_equipe';
import BtComentarioEquipe        from '../../../container/bt_comentario_timeline_equipe';
import TimeLineItem              from '../../../container/renderTimeLineEquipe';

class Equipe_Aluno_Item_Post extends Component {

    constructor(props){
        super(props);
        this.state = {
                        like             : "#AAB8BE",
                        ListItemPosts    : [],
                        ItemPostTimeline : [],
                        showModal        : false

                    }
    }

    close() {
       this.setState({showModal: false});
    }
    
    open(val) {
       this.setState({showModal: true,ItemPostTimeline:this.props.all_equipe_posts[val]});
    }

    excluirPostGrupo(id){
        const acao  = window.confirm("Deseja Remover?");
        if (acao) {
            this.props.GetRemoverPostEquipe(this.props.session.id,id);
        }
    }   

    renderListItemPosts(){

         const retornoListaItem = this.props.all_equipe_posts;

         if(retornoListaItem.length){

                return retornoListaItem.map((elem,i)=>{
                    
                        //Componente gerador botao de like    
                        const btLike       = <BtLikeEquipe vetor={i} funcao={this.likePost.bind(this,elem.equ_pos_id)}/>;
                        //Componente gerador botao de comentario
                        const btComentario = <BtComentarioEquipe vetor={i} funcao={this.open.bind(this,i)}/>;
                        const btAcao       = <span>{btLike} {btComentario}</span>;                  

                            return  <TimeLineItem
                                        key          = {i}
                                        id           = {elem.equ_pos_id}
                                        foto         = {elem.use_foto}
                                        nome         = {elem.use_nome}
                                        btAcao       = {elem.equ_pos_cod_usuario === this.props.session.id ? <BtAcaoComentario funcao={this.excluirPostGrupo.bind(this,elem.equ_pos_id,i)}/> : ""}
                                        dataCriado   = {elem.created_at}
                                        postConteudo = {elem.equ_pos_post}
                                        midia        = {elem.equ_pos_midia}
                                        tipo         = {elem.equ_pos_tipo}
                                        postMidia    = {<div dangerouslySetInnerHTML={{__html: this.props.GetTipoMidiaPost(elem)}} />}
                                        footerPost   = { btAcao }
                                        /> 
                        });

         }else{
             return <FlashRetornoNulo text="Seja o primeira a publicar na equipe."/>;
         }
    }

    likePost(val){
     
        this.props.SetLikePostUser(val,this.props.session.id);
    }

    render () {
     
        return (<div>
                   <ul className="timeline">
                     {this.renderListItemPosts()}
                   </ul>
                   <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
                   <Modal.Header closeButton>
                     
                    </Modal.Header>
                      <EquipeAlunoComentarioPost ItemPostTimeline={this.state.ItemPostTimeline}/> 
                   </Modal>
                 </div>);
    }
}

function  mapStateToProps(state){

    return {
       session         : state.auth.session,
       all_equipe_posts : state.equipeReducer.all_equipe_posts
    }
}

export default connect(mapStateToProps,{SetLikePostUser,GetTipoMidiaPost,GetQtdCommentPost,GetRemoverPostEquipe})(Equipe_Aluno_Item_Post);




// WEBPACK FOOTER //
// ./src/components/professor/timeline_equipe/equipe_aluno_post_item.js